<template>
  <div class="h-dialogContainer h-track-tabPage">
    <div class="row"></div>
      <BatchDeployImsDetail ref='batchDeployImsDetail'></BatchDeployImsDetail>

      <div class="h-borderBox h-subscriber-parseList h-dp-deploy-style">
        <div class="h-dialog-borderBox-topIcon">
          <span class="h-red-code">* </span>
          {{$t('NSMF.neDeploy')}}
          <div class="h-toolbarBg dialog-icon-style">
            <ejs-toolbar class="dialog-icon-style">
              <div class="dialog-icon-style"></div>
            </ejs-toolbar>
          </div>
        </div>

        <div class="row" v-for="(neType, index) in neTypeList" :key="index">
          <div class="col-sm-6 h-col-inputBox" style="margin-top:10px" id="neDeployBox">
            <ejs-checkbox
              ref="neTypeCheck"
              name="neDeploy"
              :label="neType.label"
              :value="neType.value"
              :checked="neType.checked"
              :change="neTypeChangeFunc"
              :disabled="neType.disabled"
            ></ejs-checkbox>
          </div>       
          <div
            :id='"sliceProfile"+neType.value'
            class="col-sm-12"
            style="display:none;margin-top:10px"
          >
            <ejs-grid
              :dataSource="serviceAllData"
              :ref="'sliceProfileGrid'+neType.value"
              height="auto"
              :rowSelected="clickDeploy"
              :id='"sliceProfileGridId"+neType.value'
            >
           <e-columns>
            <e-column field='deliverType' minWidth='10' :headerText='$t("DeployManagement.deliverTypeStr")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip'></e-column>
            <e-column field='pkgVersion' minWidth='10' :headerText='$t("DeployManagement.version")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip'></e-column>
            <e-column field='deployedCount' minWidth='10' :headerText='$t("DeployManagement.deployCount")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip'></e-column>
            <e-column field='exist' minWidth='10' :headerText='$t("DeployManagement.hasPkg")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip'></e-column>
            <e-column field='createTime' minWidth='10' :headerText='$t("DeployManagement.createTime")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip'></e-column>        
           </e-columns>
           </ejs-grid>
          </div>

          <div
            class="col-sm-12"
            :id='"deployCase"+neType.value'
            style="display:none;margin-top:20px"
          >
            <DeployIMSDialog :ref="'deployCase'+neType.value" :oamTypeCodeParent='neType.value'></DeployIMSDialog>
          </div>
        </div>
      </div>

  </div>
</template>
<script>
import { EventBus } from "../../../plugins/eventBus";
import { FormValidator } from "@syncfusion/ej2-vue-inputs";
import DeployIMSDialog from "./deployIMSDialog";
import BatchDeployImsDetail from "./batchDeployImsDetail";

export default {
  name: "BatchDeployIms",
  components: {
    DeployIMSDialog,
    BatchDeployImsDetail,
  },
  data() {
    return {
      runModeWhole:"1",
      neTypeList: [
        { label: "HSS", value: "43", checked: false },
        { label: "PCSCF", value: "44", checked: false },
        { label: "ICSCF", value: "45", checked: false },
        { label: "SCSCF", value: "46", checked: false },
        { label: "MRF", value: "47", checked: false },
        { label: "MMTELAS", value: "48", checked: false },
      ],
      netypeAll: ["43", "44", "45", "46", "47","48"],
      serviceAllData: [],
      existMap: {
        0: this.$t("DeployManagement.exist"),
        1: this.$t("DeployManagement.notExist")
      },
      deliverMap: {
        // 交付方式 0:native 老的enb和epc包 / 1:image 镜像包 / 2:helm 5GC包
        0: "Native",
        1: "Image",
        2: "Helm",
        3: "Vm"
      },
      neMap: {
        // D项目
        43: "HSS",
        44: "PCSCF",
        45: "ICSCF",
        46: "SCSCF",
        47: "MRF",
        48: "MMTELAS",       
      },
      neTypeArray: [],
      neDeploy: [],
      neTypeName: "",
      locale: localStorage.getItem("locale"),
    };
  },
  methods: {
    neTypeChangeFunc() {
      this.$refs.batchDeployImsDetail.init();
      this.$nextTick(() => {
      this.neTypeArray = this.getArray("neDeployBox");
      this.neDeploy = this.neTypeArray;});
    },
    getArray(id) {
      let checkedDom = [];
      let checkedDomUnCheck = [];
        checkedDom = document.querySelectorAll(
          `#${id} [aria-checked=true] input`
        );
        checkedDomUnCheck = document.querySelectorAll(
          `#${id} [aria-checked=false] input`
        );

      const array = [];
      const arrayLabel = [];
      for (let i = 0; i < checkedDom.length; i++) {
        document.getElementById("sliceProfile" + checkedDom[i].value).style.display = "block"; //显示
        this.getServiceList(checkedDom[i].value,0);
        array.push(checkedDom[i].value);
        arrayLabel.push(checkedDom[i].label);

      }
      for (let i = 0; i < checkedDomUnCheck.length; i++) {
        document.getElementById(
          "sliceProfile" + checkedDomUnCheck[i].value
        ).style.display = "none"; //版本列表不显示
        document.getElementById(
          "deployCase" + checkedDomUnCheck[i].value
        ).style.display = "none"; //部署详情不显示
      }

      this.neTypeName = arrayLabel;
      return array;
    },
    getServiceList(oamTypeCode,amfDeploy) {
      let oamModeValue=this.runModeWhole;
      const url = `/lte/ems/packageManager/queryServiceAll?oamTypeCode=${oamTypeCode}&oamMode=${oamModeValue}`;
      this.$axios.get(url).then(res => {
        const result = res.data;
        const showRe = [];
        let showReHasPkg = [];
        const urlNew = `/lte/ems/packageManager/findUpBackPackage?oamTypeCode=${oamTypeCode}&deliverType=${result[0].deliverType}`;
        // 查询是否存在软件包
        this.$axios.get(urlNew).then(res => {
          showReHasPkg = this.handlerPkgPackage(res.data);
          const detailOperate = this.$t("DeployManagement.detail");
          result.forEach((item, index) => {
            const re = item;
            re.deliverTypeId = item.deliverType;
            re.deliverType = this.deliverMap[item.deliverType];
            re.pkgVersion = item.pkgVersion;
            re.deployedCount = item.deployedCount;
            re.createTime = item.createTime;
            re.serviceName = this.neMap[item.oamTypeCode];
            const reHasPkg = showReHasPkg.filter(
              item => item.deliverVersion == re.pkgVersion
            );
            re.existNum = reHasPkg[0] ? reHasPkg[0].existNum : 1;
            re.exist = this.existMap[re.existNum];
            re.chartPath = reHasPkg[0] ? reHasPkg[0].chartPath : "";
            re.configPath = reHasPkg[0] ? reHasPkg[0].configPath : "";
            showRe.push(re);
          });
          if(amfDeploy==0){//除共享网元之外的
          this.$refs[`sliceProfileGrid${oamTypeCode}`][0].dataSource = showRe;

          }else{
          this.$refs[`sliceProfileGrid${amfDeploy}`][0].dataSource = showRe;

          }
        });
      });
    },

    // 判断是否存在软件包
    handlerPkgPackage(result) {
      const adapter = result.filter(item => item.pkgType === 0);
      const pkg = result
        .filter(item => item.pkgType === 1)
        .map(item => {
          const { packageName, pkgVersion } = item;
          return {
            packageName,
            pkgVersion
          };
        });
      const serverPkg = result
        .filter(item => item.pkgType === 2)
        .map(item => {
          const { packageName, pkgVersion } = item;
          return {
            packageName,
            pkgVersion
          };
        });
      const chartConfig = result
        .filter(item => item.pkgType === 3)
        .map(item => {
          const { packageName, pkgVersion, chartPath, configPath } = item;
          return {
            packageName,
            pkgVersion,
            chartPath,
            configPath
          };
        });
      const showRe = [];
      adapter.forEach(item => {
        const re = { upVersion: [] };
        re.deliverType = item.deliverType;
        re.deliverName = this.deliverMap[item.deliverType];
        re.deliverVersion = item.pkgVersion;
        const tempN = pkg.filter(it => it.packageName === item.packageName);
        const tempS = serverPkg.filter(
          it => it.packageName === item.packageName
        );
        const tempConfig = chartConfig.filter(
          it => it.packageName === item.packageName
        );
        if (Object.keys(tempN).length === 1) {
          // native 类型，检查是否存在升级包pkg(2个)
          re.existNum = 0;
          re.pkgType = 1;
          re.upVersion = tempN.map(re => re.pkgVersion);
        } else if (Object.keys(tempS).length === 1) {
          // image/helm类型，检查是否存在软件包
          re.existNum = 0;
          re.pkgType = 2;
          re.upVersion = tempS.map(re => re.pkgVersion);
        } else {
          re.existNum = 1;
        }
        if (Object.keys(tempConfig).length === 1) {
          // chart，检查是否存在软件包
          re.existNum = 0;
          re.chartPath = tempConfig.map(re => re.chartPath)[0];
          re.configPath = tempConfig.map(re => re.configPath)[0];
        }
        re.exist = this.existMap[re.existNum];
        showRe.push(re);
      });
      return showRe;
    },

    clickDeploy(args) {
      let sendData = args.data;
      let idOnly = args.row.offsetParent.parentElement.offsetParent.id.replace("sliceProfileGridId","");//checkbox设置的ID唯一
      sendData["optionName"] = idOnly;
      document.getElementById(
        "deployCase" + idOnly
      ).style.display = "block"; //显示部署详情
      if (sendData.deliverTypeId === 2) {
        // D项目的helm部署方式
        this.$refs[`deployCase${idOnly}`][0].clear();
        this.$refs[`deployCase${idOnly}`][0].getJson(sendData);
      }
    },

    clear() {
      this.neTypeList = [
        { label: "HSS", value: "43", checked: false },
        { label: "PCSCF", value: "44", checked: false },
        { label: "ICSCF", value: "45", checked: false },
        { label: "SCSCF", value: "46", checked: false },
        { label: "MRF", value: "47", checked: false },
        { label: "MMTELAS", value: "48", checked: false },
      ];
      this.$forceUpdate();
    },

    getKey(obj, value) {
      for (let key in obj) {
        if (value === obj[key]) {
          return key;
        }
      }
    },
    checkValidate() {
      let neConfigList = [];
      if (this.neDeploy.length == 0) {
        //不勾选任何数据不允许下发
        EventBus.$emit("toast", {
          type: "warning",
          content: this.$t("NSMF.disableSend")
        });
        return false;
      }
      for (var i = 0; i < this.neDeploy.length; i++) {
        const neCodeOne = this.neDeploy[i];
        let params = {};
        if (
            document.getElementById("deployCase" + neCodeOne).style.display ==
            "block"
          ) {
            //只有打开部署弹框的再获取部署值
            params = this.$refs[
              `deployCase${neCodeOne}`
            ][0].checkGetTemplateJson(); //只校验
            if (!params) {
              return false;
            }
          } else {
            //未打开部署弹窗的时候提示填写部署信息
            EventBus.$emit("toast", {
              type: "warning",
              content: this.$t("NSMF.deployinfo")
            });
            return false;
          }        
      }
      return true;
    },
    dataInfo(sliceProfileDetail) {
      if (this.checkValidate()) {
        //先校验，都通过再获取数据
        let neConfigList = [];
        for (var i = 0; i < this.neDeploy.length; i++) {
          const neCodeOne = this.neDeploy[i];
          let params = {};
          params = this.$refs[`deployCase${neCodeOne}`][0].getTemplateJson();
         neConfigList.push(params);
        }
        return neConfigList;
        
      }
    },
    getFormData(callback) {
      this.$refs.batchDeployImsDetail.getInstanceBase(res => {
        if (!res) {
          if (callback) {
            callback(false);
          }
        } else {
          let sliceProfileDetail = res;
          if (callback) {
            callback(this.dataInfo(sliceProfileDetail));
          }
        }
      });
    },
  },
  created(){
  },
};

</script>
